import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import "./App.css";
import { MenuProvider } from "./components/MenuProvider";
import { DrawerProvider } from "./components/context/DrawerContext"; //
import { ScreenHelpProvider } from "./components/help/ScreenHelp";
import { MenuStateProvider } from "./components/context/MenuStateContext";
import { HashRouter as Router, Routes, Route } from "react-router-dom";

import { SelectionProvider } from './components/context/SelectionContext';
// import {  BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import UserList from "./pages/admin/users/UserList";
import UserNew from "./pages/admin/users/UserNew";
import OfficeList from "./pages/admin/offices/OfficeList";
import OfficeNew from "./pages/admin/offices/OfficeNew";
import OfficeEdit from "./pages/admin/offices/OfficeEdit";

import PermissionList from "./pages/admin/permissions/PermissionList";
import PermissionNew from "./pages/admin/permissions/PermissionNew";

import ExpenseTypeList from "./pages/admin/expense-types/ExpenseTypeList";
import ExpenseTypeNew from "./pages/admin/expense-types/ExpenseTypeNew";
import ExpenseTypeEdit from "./pages/admin/expense-types/ExpenseTypeEdit";

import SalesRepList from "./pages/admin/sales-reps/SalesRepList";
import SalesRepNew from "./pages/admin/sales-reps/SalesRepNew";
import SalesRepEdit from "./pages/admin/sales-reps/SalesRepEdit";

import ClientList from "./pages/admin/clients/ClientList";
import ClientNew from "./pages/admin/clients/ClientNew";
import ClientEdit from "./pages/admin/clients/ClientEdit";

import RouteList from "./pages/admin/routes/RouteList";
import RouteNew from "./pages/admin/routes/RouteNew";
import RouteEdit from "./pages/admin/routes/RouteEdit";

import LoanTypeList from "./pages/admin/loan-types/LoanTypeList";
import LoanTypeNew from "./pages/admin/loan-types/LoanTypeNew";
import LoanTypeEdit from "./pages/admin/loan-types/LoanTypeEdit";

import LoanTypeAssign from "./pages/admin/loan-types/LoanTypeAssign";

import CashBoxList from "./pages/loans/cash-boxes/CashBoxList";

import Register from "./pages/Register";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";

import LoanList from "./pages/loans/LoanList";
import LoanNew from "./pages/loans/LoanNew";

import UserEdit from "./pages/admin/users/UserEdit";
import UserOffices from "./pages/admin/users/UserOffices";
import PrivateRoute from "./components/common/PrivateRoute";
import HelpList from "./pages/ayuda/HelpList";
import HelpGuide from "./pages/ayuda/HelpGuide";
import RequireMenuVisibility from "./components/common/RequireMenuVisibility";
import PaymentsByDate from "./pages/reports/PaymentsByDate";
import RouteDevices from "./pages/loans/route-devices/RouteDevices";
import CashBoxExpenseList from "./pages/loans/cash-boxes/CashBoxExpenseList";



import ClientLoanExport from "./pages/processes/export/ClientLoanExport";
import RouteSettlement from "./pages/processes/route-settlement/RouteSettlement";
import ExpenseNew from "./pages/loans/expenses/ExpenseNew";
import ExpenseEdit from "./pages/loans/expenses/ExpenseEdit";
import ExpenseList from "./pages/loans/expenses/ExpenseList";
import LoanPayments from "./pages/loans/LoanPayments";
import LoanTransfers from "./pages/processes/loan-transfers/LoanTransfers";

import Cancellations from "./pages/reports/Cancellations";
import Expenses from "./pages/reports/Expenses";
import ClientHistory from "./pages/reports/ClientHistory";
import LoansByDate from "./pages/reports/LoansByDate";
import Balances from "./pages/reports/Balances";
import LateLoans from "./pages/reports/LateLoans";
import CashDifferences from "./pages/reports/CashDifferences";
import DailySummary from "./pages/reports/DailySummary";
import Discounts from "./pages/reports/Discounts";
import AppSync from "./pages/reports/AppSync";
import DeletedRecords from "./pages/reports/DeletedRecords";
import SalesRepRisk from "./pages/reports/SalesRepRisk";

import ConsolidatedDay from "./pages/reports/ConsolidatedDay";
import CashBoxes from "./pages/reports/CashBoxes";
import Refinancing from "./pages/reports/Refinancing";
import CashMovements from "./pages/reports/CashMovements";

import ClientImport from "./pages/processes/client-import/ClientImport";
import LoanImport from "./pages/processes/import/LoanImport";
import LoanImportList from "./pages/processes/imports/LoanImportList";
import SyncAuditList from "./pages/processes/sync-audit/SyncAuditList";
import LoanDeletion from "./pages/processes/loan-deletion/LoanDeletion";
import ClientDeletion from "./pages/processes/client-deletion/ClientDeletion";

import { Module } from "./models/module";
import UserRoutes from "./pages/admin/users/UserRoutes";
import Wrapper from "./components/Wrapper";
import AlertSnackbar from "./components/AlertSnackbar";
import LoadingBackdrop from "./components/LoadingBackdrop";
import SalesRepOffices from "./pages/admin/sales-reps/SalesRepOffices";
import SalesRepRoutes from "./pages/admin/sales-reps/SalesRepRoutes";
import CashBoxExpenseNew from "./pages/loans/cash-boxes/CashBoxExpenseNew";
import PaymentCorrections from "./pages/loans/payment-corrections/PaymentCorrections";
import PaymentReceipt from "./pages/loans/PaymentReceipt";
import VisitOrderList from "./pages/processes/visit-orders/VisitOrderList";
import OfflineVisitOrderList from "./pages/processes/visit-orders/OfflineVisitOrderList";
import VisitOrderEditor from "./pages/processes/visit-order/VisitOrderEditor";
import RouteTracking from "./pages/processes/route-tracking/RouteTracking";
import DeviceList from "./pages/admin/devices/DeviceList";
import AlertCenter from "./pages/admin/alerts/AlertCenter";
import RouteDefaults from "./pages/admin/route-defaults/RouteDefaults";
import StorageCleanup from "./pages/admin/storage/StorageCleanup";
import NotificationPreferences from "./pages/notifications/NotificationPreferences";
import CorrectionApprovals from "./pages/loans/correction-approvals/CorrectionApprovals";
import BankList from "./pages/admin/banks/BankList";
import BankEdit from "./pages/admin/banks/BankEdit";
import BankNew from "./pages/admin/banks/BankNew";
import AppNotices from "./pages/processes/app-notices/AppNotices";
import ProductList from "./pages/inventory/products/ProductList";
import ProductForm from "./pages/inventory/products/ProductForm";
import ProductAssignments from "./pages/inventory/products/ProductAssignments";
import ProductsByRoute from "./pages/inventory/products/ProductsByRoute";
import StockReceiptList from "./pages/inventory/receipts/StockReceiptList";
import StockReceiptNew from "./pages/inventory/receipts/StockReceiptNew";
import StockTransferList from "./pages/inventory/transfers/StockTransferList";
import StockTransferNew from "./pages/inventory/transfers/StockTransferNew";
import WriteOffs from "./pages/inventory/write-offs/WriteOffs";
import ProductReturns from "./pages/inventory/returns/ProductReturns";
import Stock from "./pages/inventory/stock/Stock";
import RequireAction from "./pages/inventory/shared/RequireAction";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [isCheckingAuth, setIsCheckingAuth] = useState<boolean>(true);
  const [modules, setModules] = useState<Module[]>(() => {
    const modulesFromSession = sessionStorage.getItem("modules");
    if (modulesFromSession) return JSON.parse(modulesFromSession);
    const modulesFromLocal = localStorage.getItem("modules");
    return modulesFromLocal ? JSON.parse(modulesFromLocal) : [];
  });
  useEffect(() => {
    let mounted = true;

    const bootstrapAuth = async () => {
      try {
        // Primero se pregunta si hay sesión (responde 200 siempre): sin sesión no se pide el usuario y la consola
        // del navegador queda limpia en la pantalla de ingreso.
        const { data: session } = await axios.get("session");
        if (!session?.authenticated) throw new Error("sin sesión");
        await axios.get("user");
        if (!mounted) return;
        setIsAuthenticated(true);
      } catch (_) {
        if (!mounted) return;
        setIsAuthenticated(false);
        sessionStorage.removeItem("isAuthenticated");
        sessionStorage.removeItem("modules");
        localStorage.removeItem("modules");
      } finally {
        if (mounted) {
          setIsCheckingAuth(false);
        }
      }
    };

    bootstrapAuth();

    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    sessionStorage.setItem("isAuthenticated", isAuthenticated.toString());
  }, [isAuthenticated]);
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>("");
  const [alertSeverity, setAlertSeverity] = useState<"success" | "info" | "warning" | "error">("success");
  const [loading, setLoading] = useState<boolean>(false);

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const showAlert = useCallback(
    (message: string, severity: "success" | "info" | "warning" | "error" = "success") => {
      setAlertMessage(message);
      setAlertSeverity(severity);
      setAlertOpen(true);
    },
    [],
  );

  const showLoading = useCallback(() => {
    setLoading(true);
  }, []);

  const hideLoading = useCallback(() => {
    setLoading(false);
  }, []);

  return (
    <Router>
      <DrawerProvider>
        <MenuStateProvider>
          <SelectionProvider>
            <Routes>
              <Route path="/register" element={<Register />} />
              <Route path="/login" element={<Login setIsAuthenticated={setIsAuthenticated} setModules={setModules} />} />
              <Route
                path="/*"
                element={
                  <PrivateRoute
                    isAuthenticated={isAuthenticated}
                    isCheckingAuth={isCheckingAuth}
                    redirectPath="/login"
                  >
                    <MenuProvider initialModules={modules}>
                      <ScreenHelpProvider>
                      <Wrapper>
                        <Routes>

                          <Route path="/" element={<Dashboard showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="dashboard" element={<Dashboard showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          {/* Centro de ayuda (solo con sesión) */}
                          <Route path="ayuda" element={<HelpList />} />
                          <Route path="ayuda/:topic" element={<HelpGuide />} />

                          {/* Administrar */}
                          <Route path="admin/users" element={<UserList showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="admin/users/new" element={<UserNew showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="admin/users/:id/edit" element={<UserEdit showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="admin/users/:id/offices" element={<UserOffices showAlert={showAlert} />} />
                          <Route path="admin/users/:id/routes" element={<UserRoutes showAlert={showAlert} />} />

                          <Route path="admin/banks" element={<BankList showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="admin/devices" element={<DeviceList showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="admin/alerts" element={<AlertCenter showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="notifications/preferences" element={<NotificationPreferences showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="admin/storage" element={<StorageCleanup showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="admin/route-defaults" element={<RouteDefaults showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="admin/banks/:id/edit" element={<BankEdit showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="admin/banks/new" element={<BankNew showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          
                          <Route path="admin/offices" element={<OfficeList showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="admin/offices/new" element={<OfficeNew showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="admin/offices/:id/edit" element={<OfficeEdit showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="admin/sales-reps" element={<SalesRepList showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="admin/sales-reps/new" element={<SalesRepNew showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="admin/sales-reps/:id/edit" element={<SalesRepEdit showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="admin/sales-reps/:id/offices" element={<SalesRepOffices showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="admin/sales-reps/:id/routes" element={<SalesRepRoutes showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="admin/clients" element={<ClientList showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="admin/clients/new" element={<ClientNew showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="admin/clients/:id/edit" element={<ClientEdit showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="admin/routes" element={<RouteList showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="admin/routes/new" element={<RouteNew showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="admin/routes/:id/edit" element={<RouteEdit showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="admin/loan-types" element={<LoanTypeList showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="admin/loan-types/new" element={<LoanTypeNew showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="admin/loan-types/:id/edit" element={<LoanTypeEdit showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="admin/loan-types/assign" element={<LoanTypeAssign showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="admin/expense-types" element={<ExpenseTypeList showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="admin/expense-types/new" element={<ExpenseTypeNew showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="admin/expense-types/:id/edit" element={<ExpenseTypeEdit showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="admin/permissions" element={<PermissionList showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="admin/permissions/new" element={<PermissionNew showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="loans/expenses" element={<ExpenseList showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="loans/expenses/new" element={<ExpenseNew showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="loans/expenses/:id/edit" element={<ExpenseEdit showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route
                            path="loans/cash-boxes"
                            element={
                              <RequireMenuVisibility resourceRoute="/loans/cash-boxes">
                                <CashBoxList showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />
                              </RequireMenuVisibility>
                            }
                          />
                          <Route
                            path="loans/cash-box-expenses/new"
                            element={
                              <RequireMenuVisibility resourceRoute="/loans/cash-box-expenses/new">
                                <CashBoxExpenseNew showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />
                              </RequireMenuVisibility>
                            }
                          />
                          <Route
                            path="loans/cash-box-expenses"
                            element={
                              <RequireMenuVisibility resourceRoute="/loans/cash-box-expenses">
                                <CashBoxExpenseList showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />
                              </RequireMenuVisibility>
                            }
                          />


                          {/* Prestamos */}
                          <Route path="loans/payments" element={<LoanList showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="loans/new" element={<LoanNew showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="loans/:id/payments" element={<LoanPayments showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="loans/payments/:id/receipt" element={<PaymentReceipt showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="reports/payments-by-date" element={<PaymentsByDate showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />


                          <Route path="loans/payment-corrections" element={<PaymentCorrections showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="loans/correction-approvals" element={<CorrectionApprovals showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="loans/route-devices" element={<RouteDevices showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />


                          {/* Informes */}
                          <Route path="reports/cancellations" element={<Cancellations showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          {/* <Route path="reports/cancellations/:id/historico" element={<HistoricoCliente />} /> */}

                          <Route path="reports/expenses" element={<Expenses showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          {/* <Route path="reports/client-history" element={<HistoricoCliente  />} /> */}
                          <Route path="reports/client-history" element={<ClientHistory showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="reports/loans-by-date" element={<LoansByDate showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="reports/balances" element={<Balances showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="reports/late-loans" element={<LateLoans />} />

                          <Route path="reports/cash-differences" element={<CashDifferences showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="reports/daily-summary" element={<DailySummary showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="reports/discounts" element={<Discounts showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="reports/app-sync" element={<AppSync showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="reports/deleted-records" element={<DeletedRecords showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="reports/sales-rep-risk" element={<SalesRepRisk showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />


                          {/* Reportes */}

                          <Route path="reports/consolidated-day" element={<ConsolidatedDay showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="reports/cash-boxes" element={<CashBoxes showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="reports/refinancing" element={<Refinancing showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="reports/cash-movements" element={<CashMovements showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />


                          {/* Inventario (préstamo de producto). Cada ruta exige el permiso "Mostrar" de su menú. */}
                          <Route path="inventory/products" element={<RequireMenuVisibility resourceRoute="/inventory/products"><ProductList showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} /></RequireMenuVisibility>} />
                          <Route path="inventory/products/by-route" element={<RequireMenuVisibility resourceRoute="/inventory/products"><ProductsByRoute showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} /></RequireMenuVisibility>} />
                          <Route path="inventory/products/new" element={<RequireMenuVisibility resourceRoute="/inventory/products"><RequireAction resourceRoute="/inventory/products" action="canCreate" redirectTo="/inventory/products"><ProductForm showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} /></RequireAction></RequireMenuVisibility>} />
                          <Route path="inventory/products/:id/edit" element={<RequireMenuVisibility resourceRoute="/inventory/products"><RequireAction resourceRoute="/inventory/products" action="canUpdate" redirectTo="/inventory/products"><ProductForm showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} /></RequireAction></RequireMenuVisibility>} />
                          <Route path="inventory/products/:id/assignments" element={<RequireMenuVisibility resourceRoute="/inventory/products"><RequireAction resourceRoute="/inventory/products" action="canUpdate" redirectTo="/inventory/products"><ProductAssignments showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} /></RequireAction></RequireMenuVisibility>} />
                          <Route path="inventory/receipts" element={<RequireMenuVisibility resourceRoute="/inventory/receipts"><StockReceiptList showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} /></RequireMenuVisibility>} />
                          <Route path="inventory/receipts/new" element={<RequireMenuVisibility resourceRoute="/inventory/receipts"><RequireAction resourceRoute="/inventory/receipts" action="canCreate" redirectTo="/inventory/receipts"><StockReceiptNew showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} /></RequireAction></RequireMenuVisibility>} />
                          <Route path="inventory/transfers" element={<RequireMenuVisibility resourceRoute="/inventory/transfers"><StockTransferList showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} /></RequireMenuVisibility>} />
                          <Route path="inventory/transfers/new" element={<RequireMenuVisibility resourceRoute="/inventory/transfers"><RequireAction resourceRoute="/inventory/transfers" action="canTransfer" redirectTo="/inventory/transfers"><StockTransferNew showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} /></RequireAction></RequireMenuVisibility>} />
                          <Route path="inventory/write-offs" element={<RequireMenuVisibility resourceRoute="/inventory/write-offs"><WriteOffs showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} /></RequireMenuVisibility>} />
                          <Route path="inventory/returns" element={<RequireMenuVisibility resourceRoute="/inventory/returns"><ProductReturns showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} /></RequireMenuVisibility>} />
                          <Route path="inventory/stock" element={<RequireMenuVisibility resourceRoute="/inventory/stock"><Stock showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} /></RequireMenuVisibility>} />


                          {/* Procesos */}

                          <Route path="processes/visit-orders" element={<VisitOrderList showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="processes/visit-order" element={<VisitOrderEditor showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="processes/visit-orders/offline" element={<OfflineVisitOrderList showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="processes/route-tracking" element={<RouteTracking showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="processes/route-settlement" element={<RouteSettlement showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="processes/export" element={<ClientLoanExport />} />

                          <Route path="processes/client-import" element={<ClientImport />} />

                          <Route path="processes/import" element={<LoanImport showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="processes/imports" element={<LoanImportList showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="processes/sync-audit" element={<SyncAuditList showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route
                            path="processes/app-notices"
                            element={<AppNotices showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />}
                          />

                          <Route path="processes/loan-deletion" element={<LoanDeletion />} />

                          <Route path="processes/client-deletion" element={<ClientDeletion />} />

                          <Route path="processes/loan-transfers" element={<LoanTransfers showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                        </Routes>
                      </Wrapper>
                      <AlertSnackbar
                        open={alertOpen}
                        message={alertMessage}
                        severity={alertSeverity}
                        handleClose={handleAlertClose}
                      />
                      <LoadingBackdrop open={loading} />
                      </ScreenHelpProvider>
                    </MenuProvider>
                  </PrivateRoute>
                }
              />
            </Routes>
          </SelectionProvider>
        </MenuStateProvider>
      </DrawerProvider>
    </Router>
  );
};


export default App;
